export const DATE_FORMATTERS = {
  DAY_MONTH_YEAR: 'dd.MM.yy',
  DAY_MONTH_FULL_YEAR: 'dd.MM.yyyy',
  DAY_MONTH_FULL_YEAR_MASK: 'DD.MM.YYYY',
  DAY_SHORT_MONTH_YEAR: 'd MMM yyyy',
  FULL_YEAR_MONTH_DAY: 'yyyy-MM-dd',
  DAY_MONTH_FULL_YEAR_HOURS_MINUTES_SECONDS: 'dd.MM.yyyy HH:mm:ss',
  DAY_FULL_MONTH_FULL_YEAR_HOURS_MINUTES: 'dd MMMM yyyy HH:mm',
  DAY_MONTH_FULL_YEAR_SEPARATOR_HOURS_MINUTES: 'dd MMM yyyy, HH:mm',
  DAY_FULL_MONTH_FULL_YEAR_SEPARATOR_HOURS_MINUTES: 'dd MMMM yyyy, HH:mm',
};

export const TIME_ZONE = {
  MOSCOW: 'Europe/Moscow',
};

/**
 * Роли пользователя
 */
export enum EUserRole {
  Admin = 'admin',
  Curator = 'curator',
}

/**
 * Общие поля квери-параметров для адресной строки
 */
export enum CommonQueryNames {
  Page = 'page',
  PerPage = 'per_page',
  Search = 'search',
  Sort = 'sort',
  ActiveTab = 'active_tab',
}

/** Переводы для таблицы */
export const TABLE_TRANSLATIONS = {
  filterReset: 'Сбросить',
  emptyText: 'Нет данных',
  triggerDesc: 'Отсортировать от Я до А',
  triggerAsc: 'Отсортировать от А до Я',
  cancelSort: 'Отменить сортировку',
};

export const ICON_TYPE_TO_TEXT_MAPPER = {
  case: 'Кейс',
  medal: 'Медаль',
  message: 'Сообщение',
  server: 'Сервер',
  study: 'Обучение',
  trending_up: 'Рост',
  user: 'Пользователь',
  star: 'Звезда',
  enter: 'Ввод',
  command: 'Команда',
  code: 'Код',
  pipeline: 'Конвейер',
  box: 'Блок',
  pencil: 'Карандаш',
  checklist: 'Список',
  interface: 'Интерфейс',
  chart: 'График',
  briefcase: 'Портфель',
};
